import { Component, inject, Injector, ViewEncapsulation } from "@angular/core";
import { ObjectsDialogBaseComponent } from "./objects-dialog-base/objects-dialog-base.component";
import { UsersService } from "app/services/users.service";

@Component({
  selector: 'app-edit-object',
  templateUrl: './objects-dialog-base/objects-dialog-base.component.html',
  styleUrls: ['./objects-dialog-base/objects-dialog-base.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class EditObjectsComponent extends ObjectsDialogBaseComponent {

  private userService = inject(UsersService);


  constructor(protected injector: Injector) {
    super(injector);
    this.dialogId = "editObject";
  }

  public submit() {
    if (!this.ModelValidate())
      return;

    this.objectsService.EditObject(this.model)
      .subscribe(() => {
        this.onCreated.emit();
        this.close();
        super.submit();
      });
  }
}
